module.exports = __webpack_public_path__ + "img/shiba-klub.f678266f.jpg";